var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.66,
    height: 23.97,
    viewBox: "0 0 21.66 23.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-share",
    "data-name": "Icon material-share",
    d: "M22.55,19.943a3.5,3.5,0,0,0-2.358.927l-8.58-4.994a3.939,3.939,0,0,0,.108-.842,3.939,3.939,0,0,0-.108-.842l8.483-4.946A3.6,3.6,0,1,0,18.94,6.61a3.939,3.939,0,0,0,.108.842L10.565,12.4a3.61,3.61,0,1,0,0,5.271l8.568,5.006a3.4,3.4,0,0,0-.1.782,3.514,3.514,0,1,0,3.514-3.514Z",
    transform: "translate(-4.5 -3)",
    fill: "#e8b03e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.bd595595b9f089d19bf85aaaf9e9e358.svg";
export { ForwardRef as ReactComponent };